/**
 * Чистые helpers для возрастной группы — без зависимости от тестовых
 * данных (data/X-Y/*). Импорт этих функций из ChildInfo НЕ должен
 * подтягивать `data/index.ts` (и далее test9_11/test12_14) в main bundle —
 * это ломает code-splitting screen-компонентов теста.
 *
 * `data/index.ts` re-экспортирует эти же функции для consumer'ов внутри
 * lazy-чанков; список поддерживаемых групп здесь и в REGISTRY должен
 * сходиться (см. data/index.ts).
 */

import type { AgeGroup } from '@/types/test';

/**
 * Какие возрастные группы уже реализованы.
 * Используется на экране 2 (ChildInfo) для проверки, можно ли продолжить тест.
 *
 * Phase 2 — только 9-11. Phase 3 этап 1 — добавлена 12-14.
 * Phase 3 этап 2 — добавлена 6-8.
 */
const SUPPORTED_GROUPS: ReadonlySet<AgeGroup> = new Set<AgeGroup>([
  '6-8',
  '9-11',
  '12-14',
]);

export function isAgeGroupSupported(ageGroup: AgeGroup): boolean {
  return SUPPORTED_GROUPS.has(ageGroup);
}

/**
 * Преобразование числового возраста ребёнка в возрастную группу методологии.
 * Границы: 6-8 лет → '6-8'; 9-11 → '9-11'; 12-14 → '12-14'.
 * Для возрастов вне 6-14 возвращает null — методология не покрывает эти возрасты.
 */
export function ageToGroup(age: number): AgeGroup | null {
  if (!Number.isInteger(age)) return null;
  if (age >= 6 && age <= 8) return '6-8';
  if (age >= 9 && age <= 11) return '9-11';
  if (age >= 12 && age <= 14) return '12-14';
  return null;
}
